export const topics = [
  {
    id: 'variety-finale-scene',
    title: '综艺收官夜现场观众多角度记录汇总',
    summary:
      '收官夜散场后，不同位置的观众把自己看到的角度拼在一起，反而比现场镜头更完整。我们把大家的记录按时间顺序理了一遍。',
    category: 'live-scene',
    categoryLabel: '娱乐现场',
    tags: ['收官夜', '现场记录', '散场时刻'],
    author: '吃瓜小队 · 前排蹲点组',
    date: '2026-09-10',
    heat: 9860,
    comments: 214,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20stage%20with%20soft%20amber%20spotlights%20and%20blurred%20audience%20silhouettes%2C%20artistic%20painterly%20texture%2C%20cozy%20cream%20background%2C%20editorial%20illustration%20style%2C%20high%20detail&width=1000&height=620&seq=511-variety-finale-01&orientation=landscape',
    content: [
      '收官夜的门票在开售当天就没了，场外依旧聚着不少人。第一批到达的观众说，下午四点左右就可以看到有人陆续在入口处排队，手里拿着自制的应援牌，气氛更像是老朋友聚会。',
      '散场之后，观众们把自己在不同区域拍到的画面发了出来。有人坐得靠前，记录到的是舞台上的光影变化；有人坐在二层，留意到的却是全场一起跟唱的那几秒。把这些角度放在一起，你会发现同一场活动在每个人眼里都长得不一样。',
      '被提到最多的是中场休息时的一段小插曲：舞台侧边的工作人员临时调整了布置，前排观众自发往后挪了半步给通道让位。没有人指挥，大家很自然地就完成了。',
      '我们把这些记录按时间顺序排好，标出了大家反复提到的三个节点。需要说明的是，所有内容都来自公开可见的现场见闻，我们只做整理，不做推测。',
    ],
  },
  {
    id: 'creator-conference-waiting',
    title: '年度创作者大会蹲点：排队三小时的现场实录',
    summary:
      '为了第一排的位置，有人早上七点就到了。我们跟着几位蹲点群众，记录了从入场到散场的完整节奏。',
    category: 'on-site',
    categoryLabel: '活动现场',
    tags: ['创作者大会', '排队实录', '蹲点'],
    author: '吃瓜小队 · 蹲点记录组',
    date: '2026-09-08',
    heat: 8720,
    comments: 176,
    image:
      'https://readdy.ai/api/search-image?query=Soft%20warm%20illustration%20of%20a%20long%20queue%20outside%20a%20modern%20hall%20in%20morning%20light%2C%20abstract%20figures%20with%20umbrellas%2C%20muted%20peach%20and%20cream%20palette%2C%20editorial%20poster%20style%2C%20gentle%20texture&width=1000&height=620&seq=511-creator-conf-02&orientation=landscape',
    content: [
      '早上七点，场馆外的围栏边已经站了十几个人。他们大多拖着小型行李箱，里面装着折叠椅、保温杯和充电宝，一看就是有备而来。',
      '八点半左右人流开始变密，工作人员按区域引导队伍。有意思的是，队伍里自发形成了一种约定：谁要去买早饭，就请前后的人帮忙占一下位置。这个规矩没有人写在牌子上，但大家都懂。',
      '入场之后，前排的观众普遍反映视野比想象中好，座位间距也留得比较舒服。中场时广播提醒大家注意随身物品，前后排互相递水的情况出现了好几次。',
      '散场时人群没有一拥而散，而是顺着指引分批离场。蹲点组统计了一下，从开始排队到坐下，平均耗时接近三小时。值不值，每个人心里都有自己的答案。',
    ],
  },
  {
    id: 'city-music-festival-day1',
    title: '城市音乐节首日围观：人潮、应援与散场时刻',
    summary:
      '首日的天气不错，草地上的观众比预想中多。我们从入场到散场跟了一整天，捡出几个值得记下来的瞬间。',
    category: 'on-site',
    categoryLabel: '活动现场',
    tags: ['音乐节', '应援', '散场'],
    author: '吃瓜小队 · 外场机动组',
    date: '2026-09-06',
    heat: 7430,
    comments: 132,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20illustration%20of%20a%20grass%20field%20festival%20at%20sunset%2C%20crowd%20silhouettes%20and%20colorful%20flags%2C%20soft%20amber%20and%20terracotta%20tones%2C%20painterly%20editorial%20style%2C%20gentle%20grain&width=1000&height=620&seq=511-music-festival-03&orientation=landscape',
    content: [
      '首日中午入场时几乎不用排队，但到了傍晚主舞台开唱，草地前排的位置已经很难挤进去。很多观众选择站在稍远一点的坡地上，视野反而更开阔。',
      '应援的节奏比想象中整齐。副歌一到，场地里会同时亮起一片小灯牌，散场后地面上却出奇地干净，几乎看不到遗留的垃圾。',
      '比较暖心的一幕发生在洗手间附近：有观众晕车不舒服，旁边几个素不相识的人立刻让出了阴凉处的长椅，还分了自己带的水。',
      '散场是整晚最耗时的环节。接驳车排队接近四十分钟，建议下次来的人提前看好返程路线，或者干脆错峰晚走半小时。',
    ],
  },
  {
    id: 'drama-premiere-details',
    title: '新剧开机仪式现场：路透视角里的三个细节',
    summary:
      '开机仪式的公开画面不多，但外围的观众还是捕捉到了一些值得注意的细节，我们照例只记录、不解读。',
    category: 'live-scene',
    categoryLabel: '娱乐现场',
    tags: ['开机仪式', '路透', '细节'],
    author: '吃瓜小队 · 前排蹲点组',
    date: '2026-09-04',
    heat: 6890,
    comments: 158,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20a%20film%20slate%20and%20red%20ribbon%20on%20a%20wooden%20table%2C%20soft%20natural%20light%2C%20cream%20and%20terracotta%20palette%2C%20editorial%20still%20life%2C%20textured%20painterly%20style&width=1000&height=620&seq=511-drama-premiere-04&orientation=landscape',
    content: [
      '开机仪式安排在上午，现场布置以暖色为主，签到台旁边立着一块写有剧名的背景板，不少路过的观众都会停下来拍一张。',
      '第一个被反复提到的细节是现场的准备时间。工作人员反复调整了台子的位置，前后挪了三次才满意，看得出来很在意画面的整体效果。',
      '第二个细节和天气有关。当天的风比较大，背景板一度被吹得晃动，现场很快就有人加了配重，处理得比较利落。',
      '第三个细节则来自散场之后：地面上几乎没留下纸屑，几位工作人员在人群散去后沿着通道走了一圈做检查。这些小地方，其实比仪式本身更耐看。',
    ],
  },
  {
    id: 'weekly-trend-recap',
    title: '本周热榜盘点：从挑战赛到新梗的完整脉络',
    summary:
      '这一周的热榜换得有点快，午休刷到的和晚上刷到的经常不是同一件事。我们把主线理清楚，方便一次看懂。',
    category: 'hot-trend',
    categoryLabel: '网络热榜',
    tags: ['热榜盘点', '新梗', '脉络'],
    author: '吃瓜小队 · 热榜观察组',
    date: '2026-09-02',
    heat: 9120,
    comments: 243,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20illustration%20of%20rising%20trend%20arrows%20and%20speech%20bubbles%2C%20soft%20amber%20and%20muted%20orange%20tones%2C%20minimal%20editorial%20poster%20style%2C%20cream%20background%2C%20clean%20composition&width=1000&height=620&seq=511-weekly-trend-05&orientation=landscape',
    content: [
      '这一周的热榜，大体可以分成三条线：一条是某个挑战赛带起来的话题，一条是某个新梗的迅速扩散，还有一条则是周末活动的集中讨论。',
      '挑战赛这条线从周初开始升温，到周中达到顶点，之后热度缓慢回落。它的特点是参与门槛低，所以扩散得特别快，也特别容易看腻。',
      '新梗这条线最有意思。它一开始只是小范围的调侃，两天后被大量二次创作带火，到了周末已经成了通用的表达方式。很多人其实并不知道梗的来源，但用起来毫不违和。',
      '周末活动这条线属于典型的「集中爆发、快速回落」。如果你只关心主线，其实记住这三条就够了；其余的零散话题，大多是在这三条上衍生出来的。',
    ],
  },
  {
    id: 'fanmeeting-entry-guide',
    title: '见面会散场后：粉丝自发整理的排队与入场经验',
    summary:
      '一场见面会结束后，群里很快出现了几十条经验分享。我们挑出其中被点赞最多的几条，整理成这份入场参考。',
    category: 'circle',
    categoryLabel: '圈层动态',
    tags: ['见面会', '入场经验', '粉丝整理'],
    author: '吃瓜小队 · 圈层观察组',
    date: '2026-08-30',
    heat: 5640,
    comments: 98,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20soft%20illustration%20of%20folded%20fan%20letters%20and%20small%20light%20sticks%20on%20a%20desk%2C%20cozy%20amber%20lighting%2C%20cream%20and%20peach%20palette%2C%20editorial%20flat%20lay%2C%20gentle%20texture&width=1000&height=620&seq=511-fanmeeting-06&orientation=landscape',
    content: [
      '关于入场，被提到最多的一条是「别卡点到」。见面会通常会在正式开始前半小时停止检票，卡点的人往往要在队伍外干等。',
      '第二条和随身物品有关。场馆对包的大小有要求，提前把大包寄存能省下不少时间，尤其是散场时，寄存处会排起长队。',
      '第三条是关于位置的。很多人以为越靠前越好，但实际体验里，稍微靠后一点反而能看到完整的舞台效果，也不会被前面的人挡住视线。',
      '最后一条来自一位来过三次的观众：把充电宝和数据线放在随手能拿到的地方。散场后要联系同伴、叫车、看返程路线，手机没电是真的会慌。',
    ],
  },
  {
    id: 'short-film-week-stalls',
    title: '短片展映周蹲点：观众最常停留的三个展位',
    summary:
      '展映周的节奏比想象中慢，但有几个展位前面一直有人。蹲了半天，我们大概看懂了大家为什么停在那里。',
    category: 'backstage',
    categoryLabel: '幕后花絮',
    tags: ['短片展映', '展位', '蹲点'],
    author: '吃瓜小队 · 蹲点记录组',
    date: '2026-08-27',
    heat: 4980,
    comments: 76,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20a%20small%20film%20screening%20booth%20with%20posters%20and%20a%20projector%20beam%2C%20soft%20amber%20light%2C%20terracotta%20and%20cream%20palette%2C%20editorial%20painterly%20style&width=1000&height=620&seq=511-film-week-07&orientation=landscape',
    content: [
      '展映周的场地不大，几个展位挨得很近，走动起来很舒服。有意思的是，人流并不是均匀分布的，而是集中在三个位置上。',
      '第一个是入口右手边的手作展位。它胜在能上手体验，很多人本来只是路过，结果一坐就是十几分钟。',
      '第二个是中间的导演交流区。这里的吸引力其实来自「不确定性」，你永远不知道下一个坐下来聊天的是谁，所以总有人愿意等一等。',
      '第三个出人意料，是出口附近的一排长凳。它没什么内容，只是累了能坐。但恰恰是这里，成了不少人交换观后感的临时据点。',
    ],
  },
  {
    id: 'comic-con-day2',
    title: '漫展第二日实录：coser 与摄影师的高频互动区',
    summary:
      '第二日的人流量明显比首日大。我们跟着几位常客走了一圈，记录下几个大家都爱去的位置。',
    category: 'on-site',
    categoryLabel: '活动现场',
    tags: ['漫展', 'coser', '互动区'],
    author: '吃瓜小队 · 外场机动组',
    date: '2026-08-24',
    heat: 6320,
    comments: 121,
    image:
      'https://readdy.ai/api/search-image?query=Warm%20abstract%20illustration%20of%20a%20convention%20hall%20with%20costumed%20silhouettes%20and%20cameras%2C%20soft%20amber%20and%20muted%20orange%20light%2C%20cream%20background%2C%20editorial%20painterly%20style%2C%20gentle%20grain&width=1000&height=620&seq=511-comic-con-08&orientation=landscape',
    content: [
      '第二日刚开门，入口处就排起了一条不短的队伍。和首日相比，这天穿全套服装来的人明显更多，场内的色彩一下子丰富了起来。',
      '互动最密集的区域在场地中间偏后的位置。那里背景相对干净，光线也匀，几乎不用挑角度就能拍到不错的效果，所以摄影师和 coser 都爱往那边聚。',
      '一个不成文的默契是：想拍照的人会先举手示意，得到回应后再靠近。整个过程安静又高效，很少出现围堵的情况。',
      '下午三点之后的场次空隙，是补拍的好时机。人少了，走动方便，不少常客会专门挑这个时段回来再拍一轮。',
    ],
  },
];